import { useCallback, useRef } from 'react';
import { shouldHideSidePanel } from '@macmillan-learning/gradebook-shared';
import { useSidePanelStore } from '../store';
import { CLOSE_SIDE_PANEL } from '../store/actions';
import { getConfigObject } from '../../../utils/config';

function useSidePanel() {
  const [state, dispatch] = useSidePanelStore();
  const sidePanelRef = useRef(null);
  const url = getConfigObject().PANELS_SERVICE_URL;

  // state is null outside a SidePanelProvider (e.g. some tests)
  const isOpen = Boolean(state?.open);
  const closeSidePanelForTool = useCallback(
    (tool) => {
      const { FF_SIDE_PANEL_ACTIVE = false } = getConfigObject();
      const shouldClose = FF_SIDE_PANEL_ACTIVE && shouldHideSidePanel(tool);
      if (shouldClose && isOpen) {
        dispatch({ type: CLOSE_SIDE_PANEL });
        return true;
      }
      return false;
    },
    [dispatch, isOpen],
  );

  return {
    url,
    sidePanelRef,
    state,
    dispatch,
    closeSidePanelForTool,
  };
}

export default useSidePanel;
